module.exports = __webpack_public_path__ + "static/media/16.4505d9cc.jpg";